<template>
  <div class="page">
    <div v-if="!recoverPwdSection" class="innerPage">
      <h1>Entrar</h1>
      <el-form ref="form" :model="user">
        <el-form-item>
          <el-input
            type="email"
            placeholder="Digite o email"
            v-model="user.email"
            required
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            placeholder="Digite a senha"
            v-model="user.password"
            show-password
            required
          ></el-input>
          <el-form-item class="alerts">
            <el-alert
              id="emailNotConfirmed"
              title="Por favor, confirme o email"
              type="error"
              effect="dark"
              :closable="true"
            ></el-alert>
            <el-alert
              id="wrongCredentials"
              title="Email ou senha incorretos"
              type="error"
              effect="dark"
              :closable="true"
            ></el-alert>
            <p id="forgot" @click="showRecoverPwdSection()">
              Esqueci minha senha
            </p>
          </el-form-item>
          <el-button type="primary" @click="authUser">Entrar</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-else class="innerPage">
      <div v-if="recoverPwdForm">
        <h1>Redefinição de Senha</h1>
        <el-form ref="form" :model="user">
          <el-form-item>
            <el-input
              type="email"
              placeholder="Digite o email cadastrado"
              v-model="user.email"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleRecoverPwd"
              >Enviar</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div v-if="recoverPwdMessage">
        <div class="recoverPwdMessage" v-if="successMessage">
          As instruções para a redefinição da senha foram enviadas para o seu
          email.
        </div>
        <div class="recoverPwdMessage" v-else>
          Não existe uma conta para o email informado.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createSession } from "../../services/sessions";
import { recoverPwd } from "../../services/user";
export default {
  data() {
    return {
      user: {},
      recoverPwdSection: false,
      recoverPwdForm: false,
      recoverPwdMessage: false,
      successMessage: false,
    };
  },

  methods: {
    authUser() {
      createSession(this.user)
        .then((response) => {
          this.handleLogin(response);
        })
        .catch((error) => {
          if (error.response.data.cred == true) {
            if (
              error.response.status == 401 &&
              error.response.data.logged_in == false &&
              error.response.data.user.email_confirmed == false
            ) {
              document.getElementById("wrongCredentials").style.display =
                "none";
              document.getElementById("emailNotConfirmed").style.display =
                "block";
            }
          } else if (
            error.response.data.cred == false ||
            error.response.status == 404
          ) {
            document.getElementById("emailNotConfirmed").style.display = "none";
            document.getElementById("wrongCredentials").style.display = "block";
          }
        });
    },

    handleLogin(response) {
      if (
        response.status == 201 &&
        response.data.logged_in == true &&
        response.data.user.email_confirmed == true
      ) {
        this.$store.commit("userStatus", {
          loggedInfo: "LOGGED_IN",
          userData: response.data.user,
        });
        this.$router.push(`/`);
      }
    },

    handleRecoverPwd() {
      recoverPwd(this.user)
        .then(() => {
          this.showRecoverPwdMessage();
          this.successMessage = true;
        })
        .catch((error) => {
          this.showRecoverPwdMessage();
          console.log("recover password error", error);
        });
    },

    showRecoverPwdSection() {
      this.user = {};
      this.recoverPwdSection = true;
      this.recoverPwdForm = true;
    },

    showRecoverPwdMessage() {
      this.recoverPwdForm = false;
      this.recoverPwdMessage = true;
    },
  },
};
</script>

<style scoped>
#forgot {
  color: #909399;
  cursor: pointer;
}

#forgot:hover {
  color: #303133;
}

.page {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: #d3dce6;
  width: 40%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  overflow: overlay;
  position: relative;
  display: flex;
  text-align: center;
}

.innerPage {
  margin: 0 auto;
}

#emailNotConfirmed {
  display: none;
}

#wrongCredentials {
  display: none;
}

.recoverPwdMessage {
  text-align: center;
  margin: 50px;
  font-size: 25px;
}

.alerts {
  margin-top: 5px;
}
</style>
